<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('productRestrictionDialog.title')"
    [acceptText]="t('productRestrictionDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('productRestrictionDialog.description') }}</p>
      <ul class="restricted-products">
        @for (row of restrictedProductRows(); track row.productId) {
          <li>
            {{ row.productName }}
            <span class="restricted-products__dimension">
              {{ t('productRestrictionDialog.dimension_' + row.kind) }}
            </span>
          </li>
        }
      </ul>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
